<template>
  <div
    class="retry-notice"
    role="alert"
  >
    <v-icon
      class="retry-notice__icon"
      icon="mdi-alert-circle-outline"
      color="error"
      size="20"
    />
    <div class="retry-notice__body">
      <p class="retry-notice__text">{{ message }}</p>
      <p
        v-if="state.exhausted"
        class="retry-notice__text retry-notice__text--muted"
      >
        {{ t('marketing-agent.retry.exhausted') }}
      </p>
    </div>
    <v-btn
      v-if="retryable && !state.exhausted"
      class="retry-notice__action"
      color="primary"
      variant="text"
      size="small"
      prepend-icon="mdi-refresh"
      :loading="loading"
      @click="emit('retry')"
    >
      {{
        state.nextAttempt
          ? t('marketing-agent.retry.action-count', {
              attempt: state.nextAttempt,
              max: MAX_RETRY_ATTEMPTS,
            })
          : t('marketing-agent.retry.action')
      }}
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { MAX_RETRY_ATTEMPTS, type RetryState } from './lib/retryLimit'

withDefaults(
  defineProps<{
    message: string
    state: RetryState
    loading?: boolean
    // False for errors that would fail the same way again (validation, permission).
    retryable?: boolean
  }>(),
  { loading: false, retryable: true }
)

const emit = defineEmits<{ retry: [] }>()

const { t } = useI18n()
</script>

<style scoped>
.retry-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid rgba(var(--v-theme-error), 0.3);
  border-radius: 8px;
  background: rgba(var(--v-theme-error), 0.06);
  color: #1a1a1a;
}

.retry-notice__icon {
  flex: 0 0 auto;
  margin-top: 1px;
}

.retry-notice__body {
  flex: 1 1 auto;
  min-width: 0;
}

.retry-notice__text {
  margin: 0;
  font-size: 14px;
  line-height: 1.45;
}

.retry-notice__text--muted {
  margin-top: 4px;
  color: #5f6368;
  font-size: 13px;
}

.retry-notice__action {
  flex: 0 0 auto;
  align-self: center;
  font-weight: 700;
  letter-spacing: 0.04em;
}
</style>
